'use strict';

/**
 * Converts a string representation of a date to a Date object.
 *
 * @param prop - The string representation of the date.
 * @returns A Date object representing the parsed date, or null if the input is invalid.
 */ function toDate(prop) {
    return prop ? Date.parse(prop) : null;
}

module.exports = toDate;
